module.exports = __webpack_public_path__ + "static/media/map-animation-pause.d774a3b3.svg";